//https://boost.allnetru.dev/api/documentation#/Cities
import { createApi } from '@reduxjs/toolkit/query/react';
import { GetGeoLocationResponse } from './models';
import { baseQueryWithReauth } from '../baseQueryWithReauth';

const geoLocation = `geoLocation`;

export const geoLocationApi = createApi({
  reducerPath: geoLocation,
  baseQuery: baseQueryWithReauth,
  tagTypes: [geoLocation],
  endpoints: (build) => ({
    getGeoLocation: build.query<GetGeoLocationResponse, void>({
      query: () => {
        return {
          url: `/geo/location`,
          headers: {
            Accept: 'application/json', // Specify JSON response
          },
        };
      },
    }),
  }),
});

export const { useGetGeoLocationQuery } = geoLocationApi;
